import { Component, inject } from '@angular/core';
import { SpinnerService } from '../../../services/spinner-service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-spinner',
  imports: [TranslateModule],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class Spinner {
  spinnerService = inject(SpinnerService);
}
